<script lang="ts">
    import Icon from '@iconify/svelte'

    import PopEntry from 'hydria/components/PopEntry.svelte'
    import { uuid } from 'hydria/document_helpers'
    import { gettext as _, resolve, tgettext } from 'hydria/services/gettext'
    import { onMount } from 'svelte'

    interface Props {
        saved: boolean
        value: boolean
        trueIsDanger?: boolean
        falseIsDanger?: boolean
        disabled?: boolean
        label?: any
        trueText?: any
        falseText?: any
        isValid?: any
        save?: (v) => void
    }

    let { saved: savedValue, value: currentValue = $bindable(), trueIsDanger = true, falseIsDanger = false, disabled = false, label = tgettext('Indexation'), trueText = tgettext('Le document sera exclu de l’indexation des moteurs de recherche.'), falseText = tgettext('Le document sera indexé sur les moteurs de recherche.'), isValid = (value: boolean) => true, save }: Props = $props()

    let value: boolean = $state(false)

    function load(currentValue: boolean) {
        if (value !== currentValue) value = currentValue
    }

    let savedIsValid = isValid(savedValue)
    let open = $state(false)

    function keep() {
        currentValue = value
        if (save) save(currentValue)
        open = false
    }

    const id = uuid('t')
    let element: HTMLElement | undefined = $state()
    onMount(() => {
        load(currentValue)
    })

    let isPristine = $derived(currentValue === savedValue)
    let statusIcon: string = $derived(isPristine ? (savedIsValid ? 'mdi:check-circle' : 'mdi:alert') : isValid(currentValue) ? 'mdi:undo' : 'mdi:undo')
    let statusClass: string = $derived(isPristine ? (savedIsValid ? 'btn-link' : 'btn-danger') : isValid(currentValue) ? 'btn-outline-warning' : 'btn-outline-danger')
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape' && open) open = false
        else if (e.key == 'Enter' && e.ctrlKey && open) keep()
    }}
/>

<div class="row g-3 align-items-start">
    <div class="col-2 text-end"><label for={id} class="control-label" onclick={() => (open = true)} aria-hidden="true">{$resolve(label)}</label></div>
    <div class="col">
        {#if open}
            <PopEntry close={() => (open = false)} mounted={() => element.focus()}>
                <div class="card">
                    <div class="card-header text-bg-primary">{$resolve(label)}</div>
                    <div class="card-body">
                        <input type="checkbox" class="form-check-control" {id} bind:checked={value} bind:this={element} /> <label class="form-check-label" for={id}>{$resolve(trueText)}</label>
                    </div>
                    <div class="card-footer d-flex gap-2 justify-content-end">
                        <button type="button" class="btn btn-sm btn-secondary" onclick={() => (open = false)}>{$_('Fermer')}</button>
                        <button type="button" class="btn btn-sm btn-primary" disabled={!isValid(value)} onclick={() => keep()}>{$_('Appliquer')}</button>
                    </div>
                </div>
            </PopEntry>
        {/if}
        <div aria-hidden="true" ondblclick={() => (open = true)}>
            {#if value}
                <span class:text-danger={trueIsDanger}>{$resolve(trueText)}</span>
            {:else}
                <span class:text-danger={falseIsDanger}>{$resolve(falseText)}</span>
            {/if}
        </div>
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {statusClass}"
            disabled={isPristine}
            onclick={() => {
                currentValue = savedValue
            }}><Icon inline icon={statusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-secondary" {disabled} onclick={() => (open = true)}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
